import {SUPPORTED_CURRENCIES} from "../../common/constant";

const UserReducer = (state, action) => {
    const user = action?.payload?.user;
    switch (action.type) {
        case "GET_USER_SETTINGS":
            return {
                ...state,
                userSettings: action?.payload?.userSettings,
                loadingUserSettings: action?.payload?.loadingUserSettings,
                errorUserSettings: action?.payload?.errorUserSettings
            };
        case "UPDATE_USER_SETTINGS":
            return {
                ...state,
                userSettings: {
                    ...state?.userSettings,
                    ...action?.payload?.userSettings
                },
                loadingUserSettings: action?.payload?.loadingUserSettings,
                errorUserSettings: action?.payload?.errorUserSettings
            };
        case "GET_USER":
            return {
                ...state,
                user: {
                    ...action?.payload?.user,
                    currency: user && !SUPPORTED_CURRENCIES.includes(user?.currency) ? "CHF" : user?.currency,
                    systemCurrency: user?.currency
                },
                loadingUser: action?.payload?.loadingUser,
                errorUser: action?.payload?.errorUser
            };
        case "UPDATE_USER":
            return {
                ...state,
                user: action?.payload?.user,
                loadingUser: action?.payload?.loadingUser,
                errorUser: action?.payload?.errorUser
            };
        default:
            return {
                ...state
            };
    }
};

export default UserReducer;

